/*
  Note that relying on these naming conventions to find the correct accounts is for BETA release only, once the full
  integration with cash drawers is completed we will no longer need these constants and they should be removed.
*/
export const CASH_HANDLING_ACCOUNT_PREFIX = 'TevanoKiosk';

export const CASH_HANDLING_UNTRACKED_ACCOUNT = CASH_HANDLING_ACCOUNT_PREFIX + '-Untracked';
export const CASH_HANDLING_CASH_ACCOUNT_SUFFIX = '-Cash';
export const CASH_HANDLING_CREDIT_CARD_ACCOUNT_SUFFIX = '-CreditCard';

export const CASH_HANDLING_TRANSACTION_CREATOR_EMAIL = 'tevano@treez.io';


// WEBPACK FOOTER //
// ./src/config/paymentKiosk.js